import { render } from "./2025FeeSchedule.vue?vue&type=template&id=12108f8a"
import script from "./2025FeeSchedule.vue?vue&type=script&lang=js"
export * from "./2025FeeSchedule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__